export const META_FEATURES_TITLE = 'Fishing App Features';
export const META_FEATURES_DESCRIPTION =
  'Learn about how Fishbrain can make you a better angler. Discover the features available, and download the app to try today.';
export const META_FEATURES_CANONICAL = '/features';

export const META_FISHING_SPOT_TITLE = 'Find fishing spots near you';
export const META_FISHING_SPOT_DESCRIPTION =
  'Find the best local fishing spots with our local fishing spot map and report. See nearby locations, species, fishing forecasts and more.  Sign up for free.';
export const META_FISHING_SPOT_CANONICAL = '/features/fishing-spots';

export const META_TOP_WATERS_TITLE = 'Top waters with the best potential for great fishing.';
export const META_TOP_WATERS_DESCRIPTION =
  'Find the best fishing waters with Fishbrain’s top waters feature – explore nearby spots, filter by species, and discover locations ranked by their fishing outlook score and trophy potential.';
export const META_TOP_WATERS_CANONICAL = '/features/top-waters';

export const META_FISHID_TITLE = 'Fish Identifier - ID what fish you caught';
export const META_FISHID_DESCRIPTION =
  'When you take a photo of a fish, Fishbrain can tell you which species of fish you caught, along with several other similar species.';
export const META_FISHID_CANONICAL = '/features/fish-identifier';

export const META_FISHING_DEPTH_MAPS_TITLE = 'Fishing depth and contour maps in the Fishbrain app';
export const META_FISHING_DEPTH_MAPS_DESCRIPTION =
  'Access depth maps and contour maps that will improve your fishing. Visualize the depth of local fishing spots and plan your next trip with Fishbrain.';
export const META_FISHING_DEPTH_MAPS_CANONICAL = '/features/depth-maps';

export const META_FISHING_LOG_BOOK_TITLE = 'Fishing logbook and journal';
export const META_FISHING_LOG_BOOK_DESCRIPTION =
  'Log your catches and keep accurate notes such as size, weight and location. Fishbrain is a fishing journal in the palm of your hand. Join now for free.';
export const META_FISHING_LOG_BOOK_CANONICAL = '/features/logbook';

export const META_FISHING_WAYPOINTS_TITLE = 'Plan your next fishing trip with waypoints';
export const META_FISHING_WAYPOINTS_DESCRIPTION =
  'With the Fishbrain app you can easily add notes as "waypoints" to remember important information that will help you plan for your next fishing trip.';
export const META_FISHING_WAYPOINTS_CANONICAL = '/features/waypoints';

export const META_FISHING_FISHING_FORECAST_TITLE = 'Fishing forecasts - the best times to fish';
export const META_FISHING_FISHING_FORECAST_DESCRIPTION =
  "See the best times to fish near you with Fishbrain's fishing forecasts. See weather, tide, lunar charts and even a prediction of when fish are most active.";
export const META_FISHING_FISHING_FORECAST_CANONICAL = '/features/fishing-forecasts';

export const META_RULES_AND_REGULATIONS_TITLE = 'Rules and Regulations - fish with confidence';
export const META_RULES_AND_REGULATIONS_DESCRIPTION =
  'Quickly find where in the fishing season you are and the bag limit for your catch.';
export const META_RULES_AND_REGULATIONS_CANONICAL = '/features/rules-and-regulations';
